/**
 * Synkro CLI Authentication Module
 *
 * Exports authentication functions for use throughout the CLI.
 */

export {
  authenticate,
  isAuthenticated,
  getCurrentUserId,
  getUserInfo,
  getAccessToken,
  loadCredentials,
  saveCredentials,
  clearCredentials,
  getSecrets,
  isTokenExpired,
  refreshToken,
  ensureValidToken,
} from './stub.js';

export type { AuthCredentials, UserInfo, AuthStatus } from './stub.js';
